import { useCallback, useEffect, useState } from "react"

type PermissionState = "prompt" | "granted" | "denied"

export function useMicrophonePermission() {
  const [state, setState] = useState<PermissionState>("prompt")

  useEffect(() => {
    navigator.permissions
      .query({ name: "microphone" as PermissionName })
      .then((status) => {
        setState(status.state as PermissionState)
        status.addEventListener("change", () => {
          setState(status.state as PermissionState)
        })
      })
      .catch(() => {
        // Permissions API is unreliable in Electron; leave as prompt and probe on click.
      })
  }, [])

  const request = useCallback(async (): Promise<boolean> => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      stream.getTracks().forEach((t) => t.stop())
      setState("granted")
      return true
    } catch {
      setState("denied")
      return false
    }
  }, [])

  return { state, request }
}
